import { useState } from 'react';

/**
 * Bootstrap configurator state from navigation (edit saved drawing).
 * @param {object} location - react-router location
 * @param {object} defaultConfig - factory result for fresh config
 * @param {(loaded: object) => object} [transform] - optional merge/normalize
 */
export function useConfiguratorLoadState(location, defaultConfig, transform) {
  const loadConfig = location.state?.loadQuoteConfig;
  const editQuoteId = location.state?.editQuoteId || null;

  const [config, setConfig] = useState(() => {
    const resolveDefault = () =>
      typeof defaultConfig === 'function' ? defaultConfig() : defaultConfig;

    if (
      loadConfig &&
      typeof loadConfig === 'object' &&
      !Array.isArray(loadConfig)
    ) {
      const cloned = JSON.parse(JSON.stringify(loadConfig));
      return transform ? transform(cloned) : cloned;
    }

    return resolveDefault();
  });

  return { config, setConfig, editQuoteId, isEditingDrawing: Boolean(editQuoteId) };
}